import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class ClassificationService {
  private baseUrl = environment.baseUrl
  private resource: string = 'tipoClassificacao'

  constructor(private httpClient: HttpClient) {}

  public getCountryState(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `file/lib/countries_states_ptBR.json`,
    )
  }

  public createAlert(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editAlert(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update`,
      model,
    )
  }

  public deleteAlert(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${model}`)
  }

  public listPagedAlert(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listAlert(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}alerta-config/completo`,
    )
  }

  public searchLocation(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public searchLocationCityState(
    // model: SearchLocationModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search/cidade-estado`,
      model,
    )
  }

  public getLocationbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedLocation(
    page: number,
    rows: number = 15,
    model: any,
    // model: SearchLocationModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
